<template>
  <div
    :class="[
      'col-6 column items-center q-py-md cursor-pointer relative-position',
      { 'bg-white': active, 'bg-primary-semi-dark': !active }
    ]"
    @click="$emit('select')"
  >
    <QImg
      :src="active ? activeImg : img"
      alt="Novated lease"
      height="38px"
      contain
      basic
    />
    <span
      v-if="label"
      :class="[
        'q-pt-sm',
        { 'text-primary-semi-dark': active, 'text-primary-semi-light': !active }
      ]"
    >
      {{ label }}
    </span>
    <QSpinnerDots
      v-if="loading"
      class="q-mt-xs"
      size="md"
      :color="active ? 'primary-semi-dark' : 'white'"
    />
    <h4
      v-else
      :class="[
        'text-primary q-pt-xs',
        { 'text-primary-semi-dark': active, 'text-white': !active }
      ]"
    >
      {{ monetaryValue | currency }}
    </h4>
    <div v-if="active" class="active-indicator" />
  </div>
</template>

<script>
import { QImg, QSpinnerDots } from 'quasar';
import { getAsset } from 'ecx.saigon.ui.common';

export default {
  name: 'BudgetPayComparisonOption',
  props: {
    loading: Boolean,
    label: String,
    imgPath: String,
    activeImgPath: String,
    monetaryValue: undefined,
    active: Boolean
  },
  data() {
    return {
      img: undefined,
      activeImg: undefined
    };
  },
  async mounted() {
    this.img = await getAsset(this.imgPath);
    this.activeImg = await getAsset(this.activeImgPath);
  },
  components: {
    QImg,
    QSpinnerDots
  }
};
</script>

<style lang="sass" scoped>
.active-indicator
  background: $primary
  position: absolute
  width: 80%
  height: 2px
  left: 0
  right: 0
  bottom: 0
  margin: auto
</style>
